// extracted by mini-css-extract-plugin
module.exports = {"todolist":"TodoList_todolist__2cFek","smileys":"TodoList_smileys__1dPw9"};